import { RootState } from "@/app/stores";
import { ITradingPair, ITradingWalletBalance, getTradingWalletBalance, listPairs  } from "@/shared/api/trading";
import { ErrorType } from "@/shared/types";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";

export const fetchTradingWallet = createAsyncThunk<
    ITradingWalletBalance,
    void,
    { state: RootState }
>('trading/fetchTradingWallet', async (_, thunkAPI) => {
    try {
        const data = await getTradingWalletBalance()
        return data.data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

export const fetchPairs = createAsyncThunk<
    ITradingPair[],
    void,
    { state: RootState }
>('trading/fetchPairs', async (_, thunkAPI) => {
    try {
        const data = await listPairs()
        return data.data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})